"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("modal", {
    attrs: {
      show: true,
      "show-close": true
    },
    on: {
      close: _vm.close
    }
  }, [_c("h1", {
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_vm._v("Por favor, descreva os motivos da rejeição do consumidor.")]), _vm._v(" "), _c("form", {
    attrs: {
      id: "formNewTypeService"
    }
  }, [_c("app-input", {
    attrs: {
      label: "Descrição do motivo",
      placeholder: "Justificativa...",
      error: _vm.$v.form.Description.$error,
      type: "textarea",
      max: "250"
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.Description, "$error", $event);
      }
    },
    model: {
      value: _vm.$v.form.Description.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.Description, "$model", $$v);
      },
      expression: "$v.form.Description.$model"
    }
  })], 1), _vm._v(" "), _c("b-button", {
    attrs: {
      slot: "footer",
      type: "is-info"
    },
    on: {
      click: _vm.checkForm
    },
    slot: "footer"
  }, [_vm._v("\n    Salvar\n  ")])], 1);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;